<template>
  <div>
    <session-lookup
      v-if="isEIAdmin"
      :expanded="expanded"
      @showTable="displayTable()"
      @toggleExpand="toggleExpand()"
    ></session-lookup>
    <client-chart v-if="showTable"></client-chart>
  </div>
</template>

<script>
import SessionLookup from "./session-lookup";
import ClientChart from "../Client/Details/client-chart";

export default {
  components: {
    SessionLookup,
    ClientChart,
  },
  data: function () {
    return {
      expanded: true,
      showTable: false,
    };
  },
  async mounted() {
    await this.$store.dispatch("sharedModule/getProviderId", null, {
      root: true,
    });
    if (!this.isEIAdmin) {
      // admins do not need a loader - they just see the session-lookup
      this.$store.commit("uxModule/setShowLoader", true);
      // if ClientOptions didn't finish yet, this will go thru the watcher when it does
      // if ClientOptions is finished, this will go thru the mounted()
      if (this.serviceId != null) {
        await this.getSCNotesForProvider();
        this.showTable = true;
        this.$store.commit("uxModule/setShowLoader", false);
      }
    }
  },
  computed: {
    providerId() {
      return this.$store.state.sharedModule.providerId;
    },
    isEIAdmin() {
      return this.$store.getters["securityModule/isEIAdmin"];
    },
    serviceId() {
      return this.$store.getters["optionsModule/getServiceId"]("SC");
    },
  },
  methods: {
    displayTable() {
      this.expanded = false;
      this.showTable = true;
    },
    toggleExpand() {
      this.expanded = !this.expanded;
    },
    async getSCNotesForProvider() {
      await this.$store.dispatch("clientModule/getSCNotesForProvider", {
        providerId: this.providerId,
      });
    },
  },
  watch: {
    async serviceId() {
      if (!this.isEIAdmin) {
        await this.getSCNotesForProvider();
        this.showTable = true;
        this.$store.commit("uxModule/setShowLoader", false);
      }
    },
  },
};
</script>